'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tracking = function () {
  function Tracking() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Tracking);

    var id = opts.id,
        published_at = opts.published_at,
        internationalGA = opts.internationalGA,
        territoryGA = opts.territoryGA,
        previewMode = opts.previewMode;

    var options = {
      debug: process.env.NODE_ENV !== 'production',
      titleCase: true,
      internationalGA: internationalGA,
      territoryGA: territoryGA,
      previewMode: previewMode
    };

    _reactGa2.default.initialize([Object.assign({}, options, { trackingId: internationalGA, gaOptions: { name: 'international' } }), Object.assign({}, options, { trackingId: territoryGA, gaOptions: { name: 'territory' } })]);
    this.id = id;
    this.published_at = published_at;
    this.date = Date.now();
    this.previewMode = previewMode;
    this.hooks = [];
    this.triggerHooks = this.triggerHooks.bind(this);
  }

  _createClass(Tracking, [{
    key: 'addHook',
    value: function addHook(fn) {
      if (typeof fn === 'function') this.hooks.push(fn);
    }
  }, {
    key: 'triggerHooks',
    value: function triggerHooks(payload) {
      payload = Object.assign({
        id: this.id,
        version: this.published_at,
        timestamp: new Date().getTime()
      }, payload);
      this.hooks.forEach(function (fn) {
        return fn(payload);
      });
    }
  }, {
    key: 'trackPageView',
    value: function trackPageView(pageName) {
      if (this.previewMode) {
        console.log('Track page view in preview ' + pageName);
        return;
      }
      var args = pageName;

      _reactGa2.default.set({ page: args });
      _reactGa2.default.pageview(args, ['international', 'territory']);
      this.triggerHooks({ type: 'pageView', args: args, included: ['international', 'territory'] });
    }
  }, {
    key: 'trackModalView',
    value: function trackModalView(pageName) {
      if (this.previewMode) {
        console.log('Track modal view in preview ' + pageName);
        return;
      }
      var args = pageName;

      _reactGa2.default.modalview(args, ['international', 'territory']);
      this.triggerHooks({ type: 'modalView', args: args, included: ['international', 'territory'] });
    }
  }, {
    key: 'trackTiming',
    value: function trackTiming(args) {
      var _ref = args || {},
          category = _ref.category,
          variable = _ref.variable,
          value = _ref.value,
          label = _ref.label;

      var duration = Date.now() - this.date;

      if (this.previewMode) {
        console.log('Track timing in preview category=' + category + ' variable=' + variable + ' value=' + (value || duration) + ' label=' + label);
        return;
      }

      var _args = {
        category: category || 'Generic Timing',
        variable: variable || 'Generic Variable',
        value: value || duration,
        label: label || 'Generic Label'
      };

      _reactGa2.default.timing(_args, ['international', 'territory']);
      this.date = Date.now();
      this.triggerHooks({ type: 'timing', args: _args, included: ['international', 'territory'] });
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(_ref2) {
      var category = _ref2.category,
          action = _ref2.action,
          label = _ref2.label,
          value = _ref2.value;

      if (this.previewMode) {
        console.log('Track event in preview category=' + category + ' action=' + action + ' value=' + value + ' label=' + label);
        return;
      }

      var args = {
        category: category || 'Generic Event',
        action: action || 'Generic Action',
        label: label || 'Generic',
        value: value || 0
      };

      _reactGa2.default.event(args, ['international', 'territory']);
      this.triggerHooks({ type: 'event', args: args, included: ['international', 'territory'] });
    }
  }, {
    key: 'trackError',
    value: function trackError(args) {
      var _ref3 = args || {},
          description = _ref3.description,
          fatal = _ref3.fatal;

      if (this.previewMode) {
        console.log('Track error in preview fatal=' + fatal + ' description=' + description);
        return;
      }

      var _args = {
        description: description,
        fatal: fatal || false
      };

      _reactGa2.default.exception(_args);
      this.triggerHooks({ type: 'error', args: _args, included: [] });
    }
  }]);

  return Tracking;
}();

exports.default = Tracking;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/Tracking.js
// module id = 861
// module chunks = 0